<template>
  <div style="cursor: pointer; height: 100%;">
    <apexchart
      height="100%"
      width="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import indicadoresAPI from '@/api/indicadores.js';
import { mapGetters } from "vuex";
import { opcoes } from "./Opcoes.js";
import {iniciarRequisicao, logout} from "@/helpers";

const SERIE_PADRAO = [0,0,0,0,0,0,0,0,0,0,0,0,0];

export default {
  data: () => ({
    options: opcoes,
    referencias: [],
    series: [],
  }),
  mounted() {
    this.montarGrafico();
  },
  watch: {
    grupoCompra() {
      this.montarGrafico();
    }
  },
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras"
    }),
    tooltip() {
      return {
        enabled: true,
        y: {
          formatter: function (val) {
            return new Intl.NumberFormat("pt-BR", {
              style: "decimal",
              maxDigits: 4
            }).format(val);
          }
        }
      }
    }
  },
  methods: {
    limpaDadosGrafico() {
      const compras = {
        name: "Rupturas por COMPRA",
        color: "rgba(214, 14, 43, 1)",
        data: SERIE_PADRAO
      };

      const drp = {
        name: "Rupturas por DRP",
        color: "#FFBF00",
        data: SERIE_PADRAO
      };

      this.series = [compras, drp];
    },
    montarGrafico() {
      this.limpaDadosGrafico();

      const headers = iniciarRequisicao();

      const params = {
        grupos: [this.grupoCompra],
        filiais: [],
        fora_de_linha: false,
        inativo_revenda: false,
        compradores: [],
        segmentos: [],
        fornecedores: [],
        filtrar_categorias_mp_pa: true,
      };

      this.$store.dispatch('loading/addRequisicao',
        indicadoresAPI.getDadosPerdaVendaRupturaGrafico(headers, params)
        .then(response => {
          const {token, rupturas} = response.data;
          localStorage.token = token;

          this.referencias = rupturas.referencias;

          this.options = {
            tooltip: this.tooltip,
            labels: rupturas.referencias,
          };

          const compras = {
            name: "Rupturas por COMPRA",
            color: "rgba(214, 14, 43, 1)",
            data: rupturas.tipos.COMPRA
          };

          const drp = {
            name: "Rupturas por DRP",
            color: "#FFBF00",
            data: rupturas.tipos.DRP
          };

          this.series = [compras, drp];
        })
        .catch(logout)
      );
    }
  },
};
</script>
